var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Test")]),_c('app-circle-loader'),_c('app-progress-bar',{attrs:{"progress":"100"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }